import locales from '@/lang/locales.json'

let defaultLocale = 'en-US'

const getTemplates = () => {
  return locales[defaultLocale].time_ago
}

const template = (t, n) => {
  const templates = getTemplates()

  return templates[t] && templates[t].replace(/%d/i, Math.abs(Math.round(n)))
}

export default (time, locale) => {
  if (typeof locale === 'string') {
    defaultLocale = locale
  }

  time = time.replace(/\.\d+/, '') // remove milliseconds
  time = time.replace(/-/, '/').replace(/-/, '/')
  time = time.replace(/T/, ' ').replace(/Z/, ' UTC')
  time = time.replace(/([+-]\d\d):?(\d\d)/, ' $1$2') // -04:00 -> -0400
  time = new Date(time * 1000 || time)

  let now = new Date()
  let seconds = ((now.getTime() - time) * 0.001) >> 0
  let minutes = seconds / 60
  let hours = minutes / 60
  let days = hours / 24
  let years = days / 365

  return getTemplates().prefix + (
    (seconds < 45 && template('seconds', seconds)) ||
    (seconds < 90 && template('minute', 1)) ||
    (minutes < 45 && template('minutes', minutes)) ||
    (minutes < 90 && template('hour', 1)) ||
    (hours < 24 && template('hours', hours)) ||
    (hours < 42 && template('day', 1)) ||
    (days < 30 && template('days', days)) ||
    (days < 45 && template('month', 1)) ||
    (days < 365 && template('months', days / 30)) ||
    (years < 1.5 && template('year', 1)) ||
    template('years', years)
  ) + getTemplates().suffix
}
